import { POSITION_ASSISTANT_COACH, POSITION_CENTER, POSITION_DEFENDER, POSITION_DRIVER, POSITION_EQUIPMENT_MANAGER, POSITION_FORWARD, POSITION_GOALKEEPER, POSITION_HEAD_COACH, POSITION_LEFT_DEFENDER, POSITION_LEFT_FORWARD, POSITION_MEDICAL_STAFF, POSITION_RIGHT_DEFENDER, POSITION_RIGHT_FORWARD, POSITION_TEAM_MANAGER } from '../store/constants/misc';
import { ENV } from './env';

const defaultGameReportRefereeExpirationTimeForTeamSignature = 1000 * 60 * 60;

const defaultPlayerFormat = [

    [ { key: 'lastname'                   }, { key: 'firstname'                   } ],
    [ { key: 'jerseyNr', type: 'jerseyNr' }, { key: 'position', style: 'inverted' } ]

];

const defaultCompactPlayerFormat = [ [

    { key: 'position',       style: 'centered,fixed'          },
    { key: 'jerseyNr',       style: 'centered,fixed,inverted' },
    { key: 'lastname',       style: 'upper'                   },
    { key: 'firstname'                                        },
    { key: 'middlename'                                       },
    { key: 'captain',        style: 'label'                   },
    { key: 'classification', style: 'label'                   }

] ];

const defaultCompactTeamOfficialFormat = [ [

    { key: 'job',            style: 'bold,centered,fixed'     },
    { key: 'lastname',       style: 'upper'                   },
    { key: 'firstname'                                        },
    { key: 'middlename'                                       }

] ];

const contexts = {
    los7: {
        label: 'American Football',
        hosts: {
            production:  'https://losaf.hockeydata.net/',
            test:        'https://losaftest.hockeydata.net/',
            development: 'https://losafdev.hockeydata.net/'
        },
        paths: {
            data:        'los/data-asp/dp/',
            leagueImage: 'los/img/leagues/'
        },
        gameReportRefereeConfig: {
            eventStaff: [
                { title: 'Medical Staff - Ambulance',     key: 'medicalStaff'                          },
                { title: 'Security',                      key: 'security'                              },
                { title: 'Chain-Crew',                    key: 'chainCrew'                             },
                { title: 'Others',                        key: 'others'                                }
            ],
            fieldEquipment: [
                { title: 'Down Box',                      key: 'downBox'                               },
                { title: 'Chain',                         key: 'chain'                                 },
                { title: 'Pylons',                        key: 'pylons'                                },
                { title: 'Yardage Marker',                key: 'yardageMarker'                         },
                { title: 'Field Markings (Lines)',        key: 'fieldMarkingsLines'                    },
                { title: 'Field Markings (Coaching Box)', key: 'fieldMarkingsCoachingBox'              },
                { title: 'Field Markings (Team Area)',    key: 'fieldMarkingsTeamArea'                 }
            ],
            gameInfo: [
                { title: 'Spiel #',                       key: 'gameName'                              },
                { title: 'Stadt',                         key: 'town'                                  },
                { title: 'Ort',                           key: 'location'                              },
                { title: 'Datum',                         key: 'gameDate',                type: 'date' },
                { title: 'Uhrzeit - Kickoff',             key: 'gameStart',               type: 'time' },
                { title: 'Uhrzeit - Spielende',           key: 'gameEnd',                 type: 'time' }
            ],
            officials: [
                { title: 'Referee',                       key: 'referee'                               },
                { title: 'Centerjudge',                   key: 'centerjudge'                           },
                { title: 'Umpire',                        key: 'umpire'                                },
                { title: 'Linesman',                      key: 'linesman'                              },
                { title: 'Linejudge',                     key: 'linejudge'                             },
                { title: 'Backjudge',                     key: 'backjudge'                             },
                { title: 'Fieldjudge',                    key: 'fieldjudge'                            },
                { title: 'Sidejudge',                     key: 'sidejudge'                             },
                { title: 'Zeitnehmer',                    key: 'timekeeper'                            },
                { title: '25-Sec. Clock',                 key: 'shotclock'                             },
                { title: 'Game-Observer',                 key: 'observer'                              }
            ],
            playerEquipment: [
                { title: 'Face-Masks - Color',            key: 'facemaskColor'                         },
                { title: 'Helmets - Color',               key: 'helmetsColor'                          },
                { title: 'Helmets - Design',              key: 'helmetsDesign'                         },
                { title: 'Jerseys - Color',               key: 'jerseysColor'                          },
                { title: 'Jerseys - Design',              key: 'jerseysDesign'                         },
                { title: 'Pants - Color',                 key: 'pantsColor'                            },
                { title: 'Pants - Design',                key: 'pantsDesign'                           },
                { title: 'Socks - Color',                 key: 'socksColor'                            },
                { title: 'Socks - Design',                key: 'socksDesign'                           }
            ],
            scores: {
                periods: [ '1', '2', '3', '4', 'EP', 'F' ],
                types:   [
                    { title: 'Score',                     key: 'score'                                 },
                    { title: 'Penalties (Anzahl)',        key: 'penaltyCount'                          },
                    { title: 'Penalties (Yards)' ,        key: 'penaltyYardage'                        }
                ]
            },
            teamInfo: [
                { title: 'Team-Name',                     key2: 'teamName'                             },
                { title: 'Vertreter',                     key2: 'representative'                       },
                { title: 'Game-Management',               key2: 'gameManager'                          },
                { title: 'Helmfarbe',                     key2: 'colorHelmets',          type: 'color' },
                { title: 'Shirtfarbe',                    key2: 'colorShirts',           type: 'color' },
                { title: 'Hosenfarbe',                    key2: 'colorPants',            type: 'color' },
                { title: 'Sockenfarbe',                   key2: 'colorSocks',            type: 'color' },
                { title: 'Disqualifikation(en)',          key2: 'disqualifications'                    }
            ]
        },
        playerPositions: [

            [ 'QB',  'Quarterback'      ],
            [ 'RB',  'Running Back'     ],
            [ 'WR',  'Wide Receiver'    ],
            [ 'OL',  'Offensive Line'   ],
            [ 'OT',  'Offensive Tackle' ],
            [ 'TE',  'Tight End'        ],
            [ 'DL',  'Defensive Line'   ],
            [ 'DT',  'Defensive Tackle' ],
            [ 'DB',  'Defensive Back'   ],
            [ 'LB',  'Linebacker'       ],
            [ 'K/P', 'Kick/Punt'        ]

        ],
        teamOfficialPositions: [],
        supports: {
            DNP:           true,
            supplementary: true
        },
        wording: {},
        playerFormats: {
            'Players.compact':       defaultCompactPlayerFormat,
            'TeamOfficials.compact': defaultCompactTeamOfficialFormat,
            'TeamOfficials':         defaultCompactTeamOfficialFormat
        }
    },
    los6: {
        label: 'Eishockey',
        hosts: {
            production:  'https://los.hockeydata.net/',
            test:        'https://lostest.hockeydata.net/',
            development: 'https://losdev.hockeydata.net/'
        },
        paths: {
            data:        'los/data-asp/dp/',
            leagueImage: 'los/img/leagues/'
        },
        gameReportRefereeConfig: null,
        playerPositions: [

            [ POSITION_GOALKEEPER,     'Goalkeeper'     ],
            [ POSITION_DEFENDER,       'Defender'       ],
            [ POSITION_LEFT_DEFENDER,  'Left Defender'  ],
            [ POSITION_RIGHT_DEFENDER, 'Right Defender' ],
            [ POSITION_FORWARD,        'Forward'        ],
            [ POSITION_LEFT_FORWARD,   'Left Forward'   ],
            [ POSITION_RIGHT_FORWARD,  'Right Forward'  ],
            [ POSITION_CENTER,         'Center'         ]

        ],
        teamOfficialPositions: [

            [ POSITION_HEAD_COACH,        'Head Coach'        ],
            [ POSITION_ASSISTANT_COACH,   'Assistant Coach'   ],
            [ POSITION_TEAM_MANAGER,      'Team Manager'      ],
            [ POSITION_DRIVER,            'Driver'            ],
            [ POSITION_MEDICAL_STAFF,     'Medical Staff'     ],
            [ POSITION_EQUIPMENT_MANAGER, 'Equipment Manager' ]

        ],
        supports: {
            captain:          true,
            extendedRoster:   true,
            lineup:           true,
            rosterPublishing: true,
            startingPlayer:   true,
            teamOfficials:    true
        },
        wording: {
            lineup: true
        },
        playerFormats: {
            'Players.compact':       defaultCompactPlayerFormat,
            'TeamOfficials.compact': defaultCompactTeamOfficialFormat,
            'TeamOfficials':         defaultCompactTeamOfficialFormat
        }
    },
    // gp: {
    //     label: 'GamePitch (Eishockey Deutschland)',
    //     hosts: {
    //         production:  'https://dp.gamepitch.de/',
    //         test:        'https://dptest.gamepitch.de/',
    //         development: 'https://dpdev.gamepitch.de/'
    //     },
    //     paths: {
    //         data:        'data/',
    //         leagueImage: 'img/leagues/'
    //     }
    // }
};

export const getUrl = ( context, path ) => contexts[ context ].hosts[ ENV ] + contexts[ context ].paths.data + path;

export const getContexts = () => {

    const c = [];

    Object.entries( contexts ).forEach( ( [ key, value ] ) => { c.push( { ...value, key } ); } );

    return c;

};

export const getLeagueImageUrl = ( context, leagueId ) => contexts[ context ].hosts[ ENV ] + contexts[ context ].paths.leagueImage + leagueId + '.png';

export const getDefaultContext = () => {

    return 'los7';

};

export const getGameReportRefereeConfig = context => contexts[ context ].gameReportRefereeConfig;

export const getGameReportRefereeExpirationTimeForTeamSignature = context => {

    return (

        ( 'gameReportRefereeExpirationTimeForTeamSignature' in contexts[ context ] )

        ? contexts[ context ].gameReportRefereeExpirationTimeForTeamSignature

        : defaultGameReportRefereeExpirationTimeForTeamSignature

    );

};

export const getPlayerFormat = ( view, context, rosters ) => {

    if ( view && contexts[ context ].playerFormats[ view ] ) {

        return contexts[ context ].playerFormats[ view ];

    }

    if ( rosters && rosters.items && rosters.items.format ) {

        return rosters.items.format;

    }

    return defaultPlayerFormat;

};

export const getPlayerPositions = context => contexts[ context ].playerPositions;

export const getTeamOfficialPositions = context => contexts[ context ].teamOfficialPositions;

export const supports = ( context, e ) => contexts[ context ].supports[ e ];

export const wording = ( context, e ) => contexts[ context ].wording[ e ];